import { reduce } from './reduce';
import { Observable } from '../Observable';
var arrReducer = function (arr, value) { return (arr.push(value), arr); };
export function toArray() {
    return function (source) {
        return new Observable(function (subscriber) {
            reduce(arrReducer, [])(source).subscribe(subscriber);
        });
    };
}
//# sourceMappingURL=toArray.js.map